import * as types from './actionTypes';  
import offeringOrdersApi from '../api/offeringOrdersApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchOfferingOrders(payload, isLoading) {

  return {
    type: types.DO_FETCH_OFFERING_ORDERS, 
    payload, isLoading
  };
}

export function doFetchOfferingOrdersRes(data) {  
  return {
    type: types.DO_FETCH_OFFERING_ORDERS_RES, 
    data
  };
}

export function fetchOfferingOrders(payload, isLoading) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      if (isLoading) {
        dispatch(loadingRes(true));
      }
      offeringOrdersApi.doFetchOfferingOrders(payload).then(data => {
        dispatch(doFetchOfferingOrdersRes(data));
        dispatch(doFetchOfferingOrdersRes(null));
        if (isLoading) {
          dispatch(loadingRes(false));
        }
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        if (isLoading) {
          dispatch(loadingRes(false));
        }
        return error
      });
    };
  }else{
    logout()
  }
  
}